import React from 'react';
import { ProductVariant } from '@zonofi/zono-money-store';
import { SVGS } from '../../assets';

interface ShareProductCheckboxProps {
  product: ProductVariant;
  selectedProducts: Set<number>;
  onSelectProduct: (val: number) => void;
}

export const ShareProductCheckbox: React.FC<ShareProductCheckboxProps> = ({
  product,
  selectedProducts,
  onSelectProduct,
}) => {
  return (
    <div className="product-card-share-checkbox">
      <div
        className={`product-card-share-checkbox-box ${
          selectedProducts?.has(product?.id) ? 'checked' : ''
        }`}
        onClick={() => onSelectProduct(product?.id)}
      >
        {selectedProducts?.has(product.id) ? (
          <img src={SVGS.Checked} alt="selected" />
        ) : null}
      </div>
    </div>
  );
};
